import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Portal } from 'react-portal';
import classnames from 'classnames';

import {
  USER_ROLE_ADMIN,
  USER_ROLE_AGENT,
  USER_ROLE_APARTMENT_LOCATOR,
} from 'common/userRoles';

import isUserAgentMobileApp from 'common/util/isUserAgentMobileApp';

import preventDefaultPropagation from 'client/helpers/preventDefaultPropagation';
import SrLink from 'client/components/SrLink/SrLink';
import branch from 'client/core/branch';

@branch({
  currentUser: ['currentUser'],
  userAgent: ['analytics', 'userAgent'],
  currentDriver: ['drivers', 'current'],
})
class SrSettingsModal extends Component {
  static propTypes = {
    onClose: PropTypes.func.isRequired,
    isOpen: PropTypes.bool.isRequired,
    currentUser: PropTypes.object.isRequired,
    userAgent: PropTypes.object.isRequired,
    currentDriver: PropTypes.object,
  };

  render() {
    const {
      isOpen,
      onClose,
      currentUser,
      userAgent,
      currentDriver,
    } = this.props;

    if (!isOpen) {
      return null;
    }

    const isMobileApp = isUserAgentMobileApp(userAgent);

    return (
      <Portal>
        <div
          onClick={onClose}
          className={classnames(
            'darkModal',
            'darkNavigator',
            { webview: isMobileApp },
          )}
        >
          <div className='choiceContainer' onClick={preventDefaultPropagation}>
            <div className='choiceGroup'>
              <div className='topLabel'>
                <span>Logged in: {currentUser.name}</span>
              </div>

              {(currentUser.roles.includes(USER_ROLE_APARTMENT_LOCATOR)
                || currentUser.roles.includes(USER_ROLE_AGENT)
                || currentUser.roles.includes(USER_ROLE_ADMIN))
                && (
                  <SrLink to='/' className='choice'>
                    <span>Go to Renter Site</span>
                  </SrLink>
                )
              }

              {currentUser.roles.includes(USER_ROLE_APARTMENT_LOCATOR) && (
                <SrLink to='/agent/locator-profile' className='choice'>
                  <span>Go to Locator Dashboard</span>
                </SrLink>
              )}

              {currentUser.roles.includes(USER_ROLE_AGENT) && (
                <SrLink to='/agent/tours' className='choice'>
                  <span>Go to Agent Dashboard</span>
                </SrLink>
              )}

              {currentUser.roles.includes(USER_ROLE_ADMIN) && (
                <SrLink to='/admin' className='choice'>
                  <span>Go to Admin Dashboard</span>
                </SrLink>
              )}

              {currentDriver && (
                <SrLink to={`/sunsetup/drivers/${currentDriver.id}/orders`} className='choice'>
                  <span>Go to Driver Dashboard</span>
                </SrLink>
              )}

              <SrLink to='/logout' className='choice red'>
                <span>Logout</span>
              </SrLink>
            </div>

            <div
              className='choice solo'
              onClick={onClose}
            >
              <span>Cancel</span>
            </div>
          </div>
        </div>
      </Portal>
    );
  }
}

SrSettingsModal.displayName = 'SrSettingsModal';

export default SrSettingsModal;
